import { useEffect, useRef, useState } from 'react';
/**
 * @name useMediaQuery
 * @description gets the breakpoint defined
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia}
 * @param mql
 * @returns {boolean}
 */
export default function useMediaQuery(mql) {
  if (process.env.NODE_ENV !== 'production' && !mql) {
    throw new Error(
      [
        'Attention useMediaQuery needs arguments',
        'Visit https://developer.mozilla.org/en-US/docs/Web/API/Window/matchMedia',
      ].join('\n')
    );
  }
  const mounted = useRef(false);
  const query = mql.replace(/^@media( ?)/m, '');
  const [match, setMatch] = useState(false);
  useEffect(() => {
    mounted.current = true;
    if (!'matchMedia' in window) {
      return undefined;
    }
    const queryList = matchMedia(query);
    function updateMatch() {
      if (mounted.current) {
        setMatch(queryList.matches);
      }
    }
    updateMatch();
    queryList.addEventListener('change', updateMatch);
    return function cleanup() {
      mounted.current = false;
      queryList.removeEventListener('change', updateMatch);
    };
  }, [query]);
  return match;
}
